<template>
    <div class="left_sub_nav">
        <ul class="left_nav_list">
            <li v-if="hasPermission('Server')" :class="{ 'active' : $route.name == 'cloud_servers' || $route.name == 'create_cloud_server' }">
                <div class="nav_list_header no_arrow border_top_none">
                    <router-link :to="{name: 'cloud_servers'}"> 
                        <span class="text">
                            Server
                        </span>
                    </router-link>
                </div>
            </li>
            <li v-if="hasPermission('Disk')" :class="{ 'active' : $route.name == 'cloud_disks' || $route.name == 'create_cloud_disk' }">
                <div class="nav_list_header no_arrow">
                    <router-link :to="{name: 'cloud_disks'}"> 
                        <span  class="text">
                            Disk
                        </span>
                    </router-link>
                </div>
            </li>
            <li v-if="hasPermission('Networking')" :class="{ 'active' : $route.name == 'cloud_networks' || $route.name == 'create_cloud_network' }">
                <div class="nav_list_header no_arrow">
                    <router-link :to="{name: 'cloud_networks'}"> 
                        <span  class="text">
                            Networking
                        </span>
                    </router-link>
                </div>
            </li>
            <li v-if="hasPermission('Port forwarding')" :class="{ 'active' : $route.name == 'port_forwardings' }">
                <div class="nav_list_header no_arrow">
                    <router-link :to="{name: 'port_forwardings'}"> 
                        <span  class="text">
                            Port Forwarding
                        </span>
                    </router-link>
                </div>
            </li>
            <li v-if="hasPermission('Firewall')" :class="{ 'active' : $route.name == 'firewalls' }">
                <div class="nav_list_header no_arrow">
                    <router-link :to="{name: 'firewalls'}">
                        <span  class="text">
                            Firewall
                        </span>
                    </router-link>
                </div>
            </li>
            <li v-if="hasPermission('SSH Keypair')" :class="{ 'active' : $route.name === 'ssh_key' }">
                <div class="nav_list_header no_arrow">
                    <router-link :to="{name: 'ssh_key'}">
                        <span  class="text">
                            SSH Keypair
                        </span>
                    </router-link>
                </div>
            </li>
            <li v-if="can('ssh_terminal')" :class="{ 'active' : $route.name === 'ssh_terminal' }">
                <div class="nav_list_header no_arrow">
                    <router-link :to="{name: 'ssh_terminal'}">
                        <span  class="text">
                            SSH Terminal
                        </span>
                    </router-link>
                </div>
            </li>
            <!-- <li>
                <div class="nav_list_header no_arrow">
                    <a href="#"> 
                        
                        <span  class="text">
                            Backup
                        </span>
                    </a>
                </div>
            </li>
            <li>
                <div class="nav_list_header no_arrow">
                    <a href="#"> 
                        
                        <span  class="text">
                            Load Balancer
                        </span>
                    </a>
                </div>
            </li>
            <li>
                <div class="nav_list_header no_arrow">
                    <a href="#"> 
                        
                        <span  class="text">
                            Certificate Manager
                        </span>
                    </a>
                </div>
            </li>
            <li>
                <div class="nav_list_header no_arrow">
                    <a href="#"> 
                        <span  class="text">
                            NAS
                        </span>
                    </a>
                </div>
            </li>
            <li>
                <div class="nav_list_header no_arrow">
                    <a href="#"> 
                        <span  class="text">
                            Monitoring
                        </span>
                    </a>
                </div>
            </li> -->
        </ul>
    </div>
</template>
<script>
    import {mapGetters} from "vuex";
    import {useAbility} from "@casl/vue";
    export default {
        name: 'service-left-menu',
        computed: {
        ...mapGetters({
            customer: 'auth/getUserInfo',
            permissions: 'serverPermissions/getServicePermission'
            }),
        },
        setup() {
            const { can } = useAbility();

            return {
            can
            };
        },
        methods: {
            hasPermission(entityName) {
                return this.permissions?.cloud_sub_service?.includes(entityName) || this.permissions?.cloud_sub_service?.includes('All');
            },
        }
    }
</script>